export default{
	'length1' : ['#77c294'],
	'length2' : ['#5ebf82', '#93cca7'],
	'length3' : ['#78a589', '#77c294', '#add7bb'],
	'length4' : ['#658270', '#5ebf82', '#93cca7', '#c7e3cf'],
	'length5' : ['#545d59', '#78a589', '#77c294', '#add7bb', '#e1f0e5'],
}


// WEBPACK FOOTER //
// ./util/color_code.js